import { IConfigurationMessageResponse, IResultTradingSettings } from '../../interfaces';
import { IPadOptions } from './pad-options.interface';
import { ITradePadBrandingConfig } from '@fnx/fx-pad';

export function combinePadOption([
    settings,
    branding,
    configuration,
]: [
    IResultTradingSettings,
    ITradePadBrandingConfig,
    IConfigurationMessageResponse,
]): IPadOptions {
    return {
        config: {
            ...branding,
            productTypes: configuration.availableProducts,
        },
        hasConfirmation: settings.clickMode.value === 'confirm',
        tradingEnabled: settings.tradingEnabled.value,
        displaySpread: settings.hasInHouseAttached,
        availableOrderTypes: settings.availableOrderTypes,
        isCurrencyInversionForESPEnable: configuration.isCurrencyInversionForESPEnable,
        isCurrencyInversionForRFSEnable: configuration.isCurrencyInversionForRFSEnable,
    };
}
